<template>
  <div class="users-validation-page">
    <div class="validation-header-wrap">
      <h3 class="validation-slelect-title">{{ $t("user.selectRole") }}</h3>
      <div class="left-part">
        <!-- <button class="users-role" v-for="(item, index) in rolesData" :key="index" @click="selectTag(item.id)" :class="{'active-button-style': item.id===roleId}">                    
                    {{item.name}}
                </button> -->
        <el-tag
          class="users-role"
          :class="{ 'active-button-style': item.id === roleId }"
          v-for="(item, index) in rolesData"
          @click="selectTag(item.id)"
          @close="closeTag(item.id)"
          :key="item.id"
          size="medium"
          closable
        >
          {{ item.name }}
        </el-tag>
      </div>
      <button
        v-if="showModuleManageLink"
        class="global-button-style"
        style="margin-right: 12px"
        @click="$router.push({ name: 'permissionModules' })"
      >
        {{ $t("router.permissionModules") }}
      </button>
      <button
        class="global-button-style"
        @click="$store.commit('windowHandle', 'addPopup')"
      >
        <img src="@/assets/img/cmb_btn_add.png" alt="add" />{{
          $t("user.addRole")
        }}
      </button>
    </div>

    <div class="app-table-container">
      <el-row :gutter="20">
        <el-col :span="12">
          <DataTable
            tableId="table-first"
            :tableProps="selectedProps"
            :tableData="selectedData"
            :tableTitle="$t('user.selectedPermission')"
            @tableHandle="selectedHandle"
          >
            <!-- <pagination
                        layout="prev, pager, next"
                        :pageSize='selectedParams.limit'
                        :total="selectedTotal"
                        @pageNum="selectPageNum"                            
                        /> -->
          </DataTable>
        </el-col>
        <el-col :span="12">
          <DataTable
            tableId="table-second"
            :tableProps="selectableProps"
            :tableData="selectableData"
            :tableTitle="$t('user.optionalPermission')"
            @tableHandle="selectableHandle"
          >
            <!-- <pagination
                        layout="prev, pager, next"
                        :pageSize='selectableParams.limit'
                        :total="selectableTotal"
                        @pageNum="selectablePageNum"
                        /> -->
          </DataTable>
        </el-col>
      </el-row>
    </div>
    <div class="footer-btn-wrap">
      <button class="global-button-style" @click="saveHandle">
        {{ $t("commonMsg.save") }}
      </button>
    </div>
    <transition-group name="fade">
      <addComponent
        v-if="addPopup"
        key="addpopup"
        :title="$t('user.addRole')"
        :ruleForm="ruleForm"
        :ruleProps="ruleProps"
        :rules="rules"
        @addEvn="addEvn"
      />

      <DelPopup key="delpopup" @deleteHandle="deleteHandle" v-if="delPopup" />
    </transition-group>
  </div>
</template>

<script>
import DataTable from "@/components/dataTable";
import addComponent from "@/components/addPopup";
import pagination from "@/components/pagination";
import DelPopup from "@/components/delPopup";
import { mapGetters } from "vuex";
import { Message } from "element-ui";
import { isAdmin } from "@/utils/routerPermission";

export default {
  name: "Roles",
  components: {
    DataTable,
    addComponent,
    pagination,
    DelPopup
  },
  computed: {
    ...mapGetters(["addPopup", "delPopup", "userInfo"]),
    showModuleManageLink() {
      return isAdmin(this.userInfo);
    },
    rules() {
      let rules = {
        name: [
          {
            required: true,
            message: this.$t("alertMsg.userRole"),
            trigger: "blur"
          }
        ]
      };
      return rules;
    },
    ruleProps() {
      let ruleProps = [
        {
          prop: "name",
          label: this.$t("user.roleName"),
          placeholder: this.$t("alertMsg.userRole")
        }
      ];
      return ruleProps;
    },
    selectedProps() {
      let selectedProps = [
        {
          prop: "name",
          label: this.$t("user.permission")
        },
        {
          prop: "handle",
          label: this.$t("commonMsg.handle"),
          width: 80,
          btn: [this.$t("commonMsg.del")]
        }
      ];
      return selectedProps;
    },
    selectableProps() {
      let selectableProps = [
        {
          prop: "name",
          label: this.$t("user.permission")
        },
        {
          prop: "handle",
          label: this.$t("commonMsg.handle"),
          width: 80,
          btn: [this.$t("commonMsg.add")]
        }
      ];
      return selectableProps;
    }
  },
  data() {
    return {
      rolesData: [],
      roleId: 1,
      tagId: "",
      ruleForm: {
        name: ""
      },
      selectedData: [],
      selectableData: [],
      selectedTotal: 0,
      selectableTotal: 0,
      selectedParams: { limit: 20, offset: 0 },
      selectableParams: { limit: 20, offset: 0 }
    };
  },
  methods: {
    addEvn(value) {
      this.$http
        .addRoles(value)
        .then(res => {
          this.getRoles();
          this.elMsg(this.$t("alertMsg.addSuccess"), "success");
          this.$store.commit("windowHandle");
        })
        .catch(error => {
          this.elMsg(this.$t("alertMsg.addFailure"), "error");
        });
    },

    getRoles() {
      this.$http
        .getRoles()
        .then(res => {
          this.rolesData = res.data.rows;
        })
        .catch(() => {});
    },

    getModules() {
      this.$http
        .getModules({ limit: 500, offset: 0 })
        .then(res => {
          let ids = this.selectedData.map(item => item.id);
          this.selectableData = res.data.rows.filter(
            item => !ids.includes(item.id)
          );
          this.selectableTotal = res.data.count;
        })
        .catch(() => {});
    },

    getRoleModules(id) {
      return new Promise((resolve, reject) => {
        this.roleId = id;
        this.$http
          .getRoleModules(id)
          .then(res => {
            this.selectedTotal = res.data.count;
            this.selectedData = res.data.rows;
            resolve();
          })
          .catch(() => {});
      });
    },

    async selectTag(id) {
      await this.getRoleModules(id);
      this.getModules();
    },

    closeTag(id) {
      this.tagId = id;
      this.$store.commit("windowHandle", "delPopup");
    },

    deleteHandle() {
      this.$http
        .delRoles(this.tagId)
        .then(res => {
          this.elMsg(this.$t("alertMsg.delSuccess"), "success");
          this.getRoles();
        })
        .catch(err => {
          this.elMsg(this.$t("alertMsg.delFailure"), "error");
        });
    },

    selectedHandle(value) {
      this.selectedData.splice(value.data.$index, 1);
      this.selectableData = [...this.selectableData, value.data.row];
    },

    selectableHandle(value) {
      this.selectableData.splice(value.data.$index, 1);
      this.selectedData = [...this.selectedData, value.data.row];
    },

    saveHandle() {
      let tempArr = this.selectedData.map(item => item.id);
      this.$http
        .updateRoleModules({ module_ids: tempArr, role_id: this.roleId })
        .then(res => {
          this.getRoleModules(this.roleId);
          this.elMsg(this.$t("alertMsg.modifySuccess"), "success");
        })
        .catch(error => {
          this.elMsg(this.$t("alertMsg.modifyFailure"), "error");
        });
    },

    //  分页
    selectPageNum(offset) {
      this.selectedParams.offset = offset;
      this.getRoleModules(this.roleId);
    },
    //  分页
    selectablePageNum(offset) {
      this.selectableParams.offset = offset;
      this.getModules();
    }
  },
  async mounted() {
    this.getRoles();
    await this.getRoleModules(this.roleId);
    this.getModules();
  }
};
</script>

<style lang="scss">
.users-validation-page {
  height: 100%;
  display: flex;
  flex-direction: column;
  .validation-header-wrap {
    min-height: 66px;
    padding: 5px 44px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .validation-slelect-title {
      width: 90px;
      margin-right: 10px;
    }
    .left-part {
      /* display: flex; */
      flex: 1;
      > span {
        font-size: 16px;
        margin-bottom: 5px;
        margin-top: 5px;
      }
      .users-role {
        background: #fff;
        /* padding: 0; */
        /* width: 92px;
                    height: 32px;
                    line-height: 32px; */
        text-align: center;
        /* margin-left:16px; */
        font-size: $globalBtnFontSize;
        border-radius: 4px;
        border: 1px solid $globalBorderColor;
        color: $globalFontSizeColor;
        outline: none;
        cursor: pointer;
        transition: all 0.3s;
        > .el-icon-close {
          font-size: 15px;
        }
        &:hover {
          background: $globalLessBGColor;
          border-color: $globalLessBGColor;
          color: #fff;
          > .el-tag__close {
            color: #fff;
            &:hover {
              background: #fff;
              color: $globalFontSizeColor;
            }
          }
        }
      }
      .active-button-style {
        color: #fff;
        border-color: $globalBGColor;
        background: $globalBGColor;
        > .el-icon-close {
          font-size: 15px;
        }
        > .el-tag__close {
          color: #fff;
          /* &:hover {
                            background:$globalFontSizeColor;
                        } */
        }
      }
    }
  }
  .app-table-container {
    flex: 1;
    overflow: hidden;
  }
  .footer-btn-wrap {
    text-align: center;
    margin-bottom: 20px;
    .global-button-style {
      width: 140px;
    }
  }
}
</style>
